import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamTHTH() {
  return (
    <div className={styles["declaration"]}>
      <h1>คำชี้แจงการปฏิบัติตามข้อกำหนดสำหรับการฝึกอบรมและการสอบของสมาชิกที่ปฏิบัติงานภาคสนาม</h1>

      <p>
        เพื่อยกระดับคุณภาพการให้บริการของพนักงานส่งเสริมการขายบุคคลที่สามซึ่งปฏิบัติงานในระดับแนวหน้าอย่างต่อเนื่อง ทีมฝึกอบรมแผนกต่างประเทศของ Xiaomi (ต่อไปนี้เรียกว่า “เรา” หรือ “บริษัทของเรา”) ได้จัดให้มีหลักสูตรการฝึกอบรมและการสอบเสริมสร้างความรู้สำหรับพนักงานส่งเสริมการขายบุคคลที่สาม (ต่อไปนี้เรียกว่า “ผู้เข้ารับการฝึกอบรม”) ที่ได้รับการแต่งตั้งจากผู้ให้บริการจ้างทำงานภายนอก จุดมุ่งหมายของการฝึกอบรมและการสอบคือเพื่อปรับปรุงเนื้อหาหลักสูตรและรวบรวมผลลัพธ์การเรียนรู้ และมิให้ถือว่าเป็นความสัมพันธ์ในรูปแบบแรงงานหรือการบริหารจัดการที่แท้จริงแต่อย่างใด ต่อไปนี้เป็นคำชี้แจงเกี่ยวกับการฝึกอบรมและการสอบ:
      </p>

      <ol>
        <li>
          <strong>ลักษณะของการฝึกอบรมและการสอบ</strong><br/>
          หลักสูตรฝึกอบรมและการสอบทั้งหมดจัดขึ้นเพื่อวัตถุประสงค์ในการแบ่งปันความรู้ มีเป้าหมายเพื่อช่วยให้ผู้เข้ารับการฝึกอบรมเข้าใจข้อมูลผลิตภัณฑ์และมาตรฐานการให้บริการอย่างเป็นระบบ ผลการสอบเป็นเพียงผลสะท้อนความเข้าใจของผู้เข้ารับการฝึกอบรมเท่านั้น และไม่ถือเป็นเกณฑ์ในการประเมินผลการปฏิบัติงาน ทั้งนี้ เราไม่มีอำนาจและจะไม่เข้าไปแทรกแซงเกี่ยวกับการประเมินผลการปฏิบัติงานของผู้ให้บริการภายนอก การจัดสรรเงินเดือน หรือเรื่องอื่นใดที่เกี่ยวข้องกับการจ้างงานของผู้เข้ารับการฝึกอบรม
        </li>
        <li>
          <strong>การชี้แจงเกี่ยวกับความสัมพันธ์ทางกฎหมาย</strong><br/>
          ความสัมพันธ์ระหว่างนายจ้างและลูกจ้างระหว่างผู้เข้ารับการฝึกอบรมและผู้ให้บริการจ้างทำงานภายนอกของตนยังคงมิได้รับผลกระทบจากโปรแกรมการฝึกอบรมและการสอบนี้ บริษัทของเราไม่มีความสัมพันธ์แบบนายจ้าง-ลูกจ้างกับผู้เข้ารับการฝึกอบรมและโปรแกรมการฝึกอบรมและการสอบแบ่งปันความรู้ก็ไม่ได้สร้างความสัมพันธ์การจ้างงานโดยพฤตินัยกับผู้เข้ารับการฝึกอบรมแต่อย่างใด สิทธิและภาระผูกพันในการจ้างงานทั้งหมดยังคงอยู่ระหว่างผู้ให้บริการจ้างทำงานภายนอกและผู้เข้ารับการฝึกอบรมเท่านั้น
        </li>
        <li>
          <strong>การนำผลการสอบไปใช้</strong><br/>
          ผลการสอบจะถูกนำไปใช้เฉพาะเพื่อวัตถุประสงค์ต่อไปนี้เท่านั้น:
          <ol type="1">
            <li>ทำหน้าที่เป็นข้อมูลอ้างอิงสำหรับการปรับปรุงและพัฒนาหลักสูตรภายในของบริษัทของเรา</li>
            <li>มอบให้กับผู้ให้บริการจ้างทำงานภายนอกเป็นหลักฐานแสดงความสามารถทางวิชาชีพของผู้เข้ารับการฝึกอบรม โดยขึ้นอยู่กับการตัดสินใจอย่างอิสระและความประสงค์ของผู้ให้บริการจ้างทำงานภายนอก</li>
            <li>ผลการสอบจะไม่ถูกเปิดเผยต่อสาธารณะหรือเปิดเผยต่อบุคคลที่สาม</li>
          </ol>
        </li>
      </ol>

      <p>
        คำชี้แจงนี้จะมีผลใช้บังคับตั้งแต่วันที่เผยแพร่ การเข้าร่วมโปรแกรมการฝึกอบรมและการสอบถือเป็นการที่ผู้เข้ารับการฝึกอบรมรับทราบและยอมรับคำชี้แจงนี้ บริษัทของเราสงวนสิทธิ์ในการตีความ และอาจแก้ไขคำชี้แจงนี้ได้เป็นครั้งคราวอย่างสมเหตุสมผล โดยที่การแก้ไขดังกล่าวจะไม่เปลี่ยนแปลงลักษณะที่ไม่ใช่การจ้างงานของการฝึกอบรมและการสอบนี้ ในกรณีที่มีข้อพิพาทหรือความไม่สอดคล้องกันระหว่างฉบับภาษาต่าง ๆ ให้ถือว่าฉบับภาษาอังกฤษมีผลบังคับใช้เป็นหลัก
      </p>

      <div className={styles["footer"]}>
        ทีมฝึกอบรมแผนกต่างประเทศของ Xiaomi<br/>
        วันที่: {getLocalizedTime('th-TH')}
      </div>
    </div>
  );
}